import { render, staticRenderFns } from "./BannerCard.vue?vue&type=template&id=ad210ce6&scoped=true"
import script from "./BannerCard.vue?vue&type=script&lang=js"
export * from "./BannerCard.vue?vue&type=script&lang=js"
import style0 from "./BannerCard.vue?vue&type=style&index=0&id=ad210ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad210ce6",
  null
  
)

export default component.exports